import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
//API 
import { CouponPosFetchAPI } from '../../../api/Coupon';
//Alerts 
import AlertError from '../../Alerts/ErrorAlert';

//Modal asing combos cupon
const ModalAsingCombosCupon = ({ showModal, setShowModal, combos, selectedCupon, setEventHandler }) => {

    //Function to add a combo to the cupon
    const addComboToCupon = async (e) => {
        e.preventDefault();
        const combo = e.target.combo.value;
        try {
            let res = await CouponPosFetchAPI.addComboToCupon(selectedCupon, combo, localStorage.getItem('x-access-token'));

            console.log(res)
            if (res.status === 200) {
                AlertError('Combo asignado correctamente', 'Exito', 'success')
                setEventHandler(1)
            }
        } catch (err) {
            console.log(err)
            AlertError(err.response.data.error !== undefined ? err.response.data.error : 'Error al asignar el combo al cupon', 'error', 'error')
        }


    }
    return (
        <div>
            <Modal
                show={showModal}
                centered
                onHide={() => setShowModal(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Asignar combo a cupón</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={addComboToCupon}>
                        <Form.Group controlId="combo">
                            <Form.Label>Combo</Form.Label>
                            <Form.Select>
                                <option value={null}>Seleccione combo...</option>
                                {combos.map((combo) => (
                                    <option key={"combo"+combo.id} value={combo.id}>{combo.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowModal(false)}>Cerrar</Button>
                            <Button variant="success" type='submit'>Guardar</Button>
                        </Modal.Footer>
                    </Form>
                </Modal.Body>


            </Modal>
        </div>
    );
}

export default ModalAsingCombosCupon;
